export default __webpack_public_path__ + "static/media/college_readiness_icon.1150b0f2.png";